<template>
  <div class="table-content">
    <div class="header">
      <!--下拉框-->
      <div class="filiale">
        <el-select v-model="value" :popper-append-to-body="false" size="small" @change="onSelectedDrug" filterable collapse-tags placeholder="请选择类别">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            <span class="check" />
            <span style="margin-left: 0.08rem;">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="filiale">
        <el-select v-model="value1" :popper-append-to-body="false" size="small" @change="onSelectedDrug1" filterable collapse-tags
          placeholder="请选择分公司">
          <el-option v-for="item in filiale" :key="item.companyId" :label="item.companyName" :value="item.companyId">
            <span class="check" />
            <span style="margin-left: 0.08rem;">{{ item.companyName }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="filiale">
        <el-select v-model="value2" :popper-append-to-body="false" size="small" @change="onSelectedDrug2" collapse-tags placeholder="请选择中支">
          <el-option v-for="item in medium" :key="item.deptId" :label="item.deptName" :value="item.deptId">
            <span class="check" />
            <span style="margin-left: 0.08rem;">{{ item.deptName }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="filiale">
        <el-select v-model="value3" :popper-append-to-body="false" size="small" @change="onSelectedDrug3" collapse-tags placeholder="请选择营服">
          <el-option v-for="item in camp" :key="item.businessId" :label="item.businessName" :value="item.businessId">
            <span class="check" />
            <span style="margin-left: 0.08rem;">{{ item.businessName }}</span>
          </el-option>
        </el-select>
      </div>
      <!--日期选择-->
      <div class="startDate">
        <el-date-picker v-model="date1" size="small" type="date" @change="getSTime1" placeholder="开始日期(注册)"
          :picker-options="getSTime1Fun">
        </el-date-picker>
      </div>
      <div class="endDate">
        <el-date-picker v-model="date2" size="small" type="date" @change="getSTime2" placeholder="结束日期(注册)"
          :picker-options="getSTime2Fun">
        </el-date-picker>
      </div>
      <!--输入框-->
      <div class="input input1">
        <img src="../../../static/img/sousuo-2.png" alt="">
        <input type="text" v-model="idCard" placeholder="请输入推荐人身份证号">
      </div>
    </div>
    <div class="fun">
      <div class="funLeft">
        <div class="input one">
          <img src="../../../static/img/sousuo-2.png" alt="">
          <input type="text" v-model="name" placeholder="请输入推荐人姓名">
        </div>
        <!--输入框-->
        <div class="input one">
          <img src="../../../static/img/sousuo-2.png" alt="">
          <input type="text" v-model="phone" placeholder="请输入推荐人手机号">
        </div>
        <div class="filiale">
          <el-select v-model="value4" :popper-append-to-body="false" size="small" @change="onSelectedDrug4" filterable collapse-tags placeholder="推荐人状态">
            <el-option v-for="item in whetherStaff1" :key="item.value" :label="item.label" :value="item.value">
              <span class="check" />
              <span style="margin-left: 0.08rem;">{{ item.label }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="input one">
          <img src="../../../static/img/sousuo-2.png" alt="">
          <input type="text" v-model="customerName" placeholder="请输入被推荐人姓名">
        </div>
        <!--输入框-->
        <div class="input ">
          <img src="../../../static/img/sousuo-2.png" alt="">
          <input type="text" v-model="mobile" placeholder="请输入被推荐人手机号">
        </div>
        <div class="input ">
          <img src="../../../static/img/sousuo-2.png" alt="">
          <input type="text" v-model="certNo" placeholder="请输入被推荐人身份证号">
        </div>
        <div class="filiale">
          <el-select v-model="value5" :popper-append-to-body="false" size="small" @change="onSelectedDrug5" filterable collapse-tags placeholder="被推荐人状态">
            <el-option v-for="item in whetherStaff2" :key="item.value" :label="item.label" :value="item.value">
              <span class="check" />
              <span style="margin-left: 0.08rem;">{{ item.label }}</span>
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="btn">
      <!--开户时间-->
      <div class="openOnAccountTime">
        <div class="startDate">
          <el-date-picker v-model="date3" size="small" type="date" @change="getSTime3" placeholder="开始日期(开户)"
            :picker-options="getSTime3Fun">
          </el-date-picker>
        </div>
        <div class="endDate">
          <el-date-picker v-model="date4" size="small" type="date" @change="getSTime4" placeholder="结束日期(开户)"
            :picker-options="getSTime4Fun">
          </el-date-picker>
        </div>
      </div>
      <el-row>
        <el-button class="search" size="mini" @click="search()">搜索</el-button>
        <el-button class="deltale" size="mini" @click="deltale()">清除</el-button>
        <el-button class="doexcel" size="mini" @click="doexcel()">导出</el-button>
      </el-row>
    </div>
    <el-table class="loadingPrivate" max-height="500" :data="tableData" style="width: 100%,font-size:0.5rem,margin-bottom:1rem">
        <!--推荐人信息-->
      <el-table-column prop="recommendName" label="推荐人" width="80"></el-table-column>
      <el-table-column prop="recommendIdCard" label="推荐人身份证号" width="120"></el-table-column>
      <el-table-column prop="recommendPhone" label="推荐人电话" width="125"></el-table-column>
      <el-table-column prop="recommendType" label="推荐人类别" width="110"></el-table-column>
      <el-table-column prop="recommendCompanyName" label="推荐人分公司" width="150"></el-table-column>
      <el-table-column prop="recommendDeptName" label="推荐人中支" width="150"></el-table-column>
      <el-table-column prop="recommendService" label="推荐人营服" width="150"></el-table-column>
      <el-table-column prop="recommendStatus" label="推荐人状态" width="150"></el-table-column>
      <el-table-column prop="recommendHireDate" label="推荐人入职时间" width="150"></el-table-column>
      <el-table-column prop="recommendLeaveDate" label="推荐人离职时间" width="150"></el-table-column>
      <!-- <el-table-column prop="recommendFunctionName" label="推荐人人员系列" width="150"></el-table-column> -->
      <!--被推荐人信息-->
      <el-table-column prop="toRecommendName" label="被推荐人姓名" width="120"></el-table-column>
      <el-table-column prop="toRecommendIdCard" label="被推荐人身份证号" width="135"></el-table-column>
      <el-table-column prop="toRecommendPhone" label="被推荐人电话" width="120"></el-table-column>
      <el-table-column prop="toRecommendType" label="被推荐人类别" width="110"></el-table-column>
      <el-table-column prop="toRecommendCompany" label="被推荐人分公司" width="150"></el-table-column>
      <el-table-column prop="toRecommendDept" label="被推荐人中支" width="150"></el-table-column>
      <el-table-column prop="toRecommendService" label="被推荐人营服" width="150"></el-table-column>
      <el-table-column prop="toRecommendStatus" label="被推荐人状态" width="150"></el-table-column>
      <el-table-column prop="toRecommendHireDate" label="被推荐人入职时间" width="150"></el-table-column>
      <el-table-column prop="toRecommendLeaveDate" label="被推荐人离职时间" width="150"></el-table-column>
      <!-- <el-table-column prop="toRecommendFunctionName" label="被推荐人人员系列" width="150"></el-table-column> -->
      <el-table-column prop="toRecommendRegisterTime" label="注册时间" width="110"></el-table-column>
      <el-table-column prop="isFlag" label="被推荐人是否开户" width="140"></el-table-column>
      <el-table-column prop="openChannel" label="是否合众金科开户" width="140"></el-table-column>
      <el-table-column prop="acctOpenDate" label="开户时间" width="110"></el-table-column>
    </el-table>
    <div class="pagination" v-if="isPage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage1" :page-size="15" layout=" prev, pager, next" :total="totalCount">
      </el-pagination>
      <div class="pagNum">共{{pagNum}}页 （共{{totalCount}}条）</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "client1", //客户全量数据表
    data() {
      return {
        tableData: [],
        paginations: {
          pageIndex: 1, // 当前位于哪页
          pageSize: 20, // 1页显示多少条
          pageSizes: [5, 10, 15, 20], //每页显示多少条
          layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
        },
        currentPage1: 1,
        options: [{
          value: 'A',
          label: '合众内勤'
        }, {
          value: 'K',
          label: '合众外勤'
        }, {
          value: 'C',
          label: '寿险客户'
        }, {
          value: 'D',
          label: '非寿险客户'
        }, {
          value: '1',
          label: '个险'
        }, {
          value: '5',
          label: '续期'
        }, {
          value: '4',
          label: '银保'
        }, {
          value: '0',
          label: '所有系列'
        }, {
          value: '2',
          label: '团险'
        }, {
          value: '6',
          label: '自聘电销人员'
        }, {
          value: '7',
          label: '中介电销人员'
        }, {
          value: '8',
          label: '网销人员'
        }, {
          value: '9',
          label: '团险客户经理'
        }, {
          value: 'E',
          label: '银行人员'
        }, {
          value: 'F',
          label: '银行管理员'
        }, {
          value: 'G',
          label: '团险银行人员'
        }, {
          value: 'B',
          label: '盛世'
        }],
        //推荐人状态
        whetherStaff1:[
          {
            value: '1',
            label: '在职'
          }, {
            value: '2',
            label: '离职'
          }, {
            value: '3',
            label: '普通用户'
          }, 
        ],
        //被推荐人状态
        whetherStaff2:[
          {
            value: '1',
            label: '在职'
          }, {
            value: '2',
            label: '离职'
          }, {
            value: '3',
            label: '普通用户'
          }, 
        ],
        options1: [],
        newOrgData: [], // 勾选改变产生的
        orgData1: [], //勾选最终数据
        orgData2: [],
        orgData3: [],
        orgData4: [],
        value: [],
        value1: [],
        value2: [],
        value3: [],
        value4: [],//推荐人状态
        value5: [],//被推荐人状态
        date1: '',
        date2: '',
        date3: '',
        date4: '',
        isPage: true,
        identityClass: "", //员工类别名称
        identityClassID: "", //员工类别id
        idCard: '', //推荐人身份证号
        certNo: '', //被推荐人身份证号
        name: '', //推荐人姓名
        customerName: '', //被推荐人姓名
        phone: '', //推荐人手机号
        mobile: '', //被推荐人手机号
        staffName1:'',//推荐人状态名称
        staffName2:'',//被推荐人状态名称
        staffID1:'',//推荐人状态id
        staffID2:'',//被推荐人状态id
        companyName: '', //分公司名
        totalCount: '', //总条数
        pagNum: '', //总页数
        token: "",
        pageNumber: 1,
        pageSize: 15,
        companyId: "", //公司Id
        filiale: [], //分公司
        medium: [], //中支
        camp: [], //营服
        deptId: "", //中支id
        abbrName: "", //中支名称
        serviceName: "", //营服名
        serviceID: "", //营服id
        startTime: "", //注册开始时间
        endTime: "", //注册结束时间
        acctOpenDateStart: "", //开户开始时间
        acctOpenDateEnd: "", //开户结束时间
        selectData: [], //导出excel文件
        excelData: [],
        //请求参数
        req: {
          identityType1: "", //员工标识:1内勤2外勤
          companyName1: "", //公司名称
          serviceName1: "", //营服名
          startTime1: "", //注册开始时间
          endTime1: "", //注册结束时间
          acctOpenDateStart1: "", //开户开始时间
          acctOpenDateEnd1: "", //开户结束时间
          recommendIdcard1: '', //推荐人身份证号
          recommendPepole1: '', //推荐人姓名
          recommendMobile1: '', //推荐人手机号
          recommendStatus1:'',//推荐人状态
          toRecommendIdcard1: '', //被推荐人身份证号
          toRecommendName1: '', //被推荐人姓名
          toRecommendMobile1: '', //被推荐人手机号
          toRecommendStatus1:'',//被推荐人状态
          deptId1: "" //中支id
        },
        //设置日历可选择日期
        getSTime1Fun: {
          disabledDate: (time) => {
            if (this.date2) return time.getTime() > this.date2
            else return
          }
        },
        getSTime2Fun: {
          disabledDate: (time) => {
            if (this.date1) return time.getTime() < this.date1
            else return
          }
        },
        getSTime3Fun: {
          disabledDate: (time) => {
            if (this.date4) return time.getTime() > this.date4
            else return
          }
        },
        getSTime4Fun: {
          disabledDate: (time) => {
            if (this.date3) return time.getTime() < this.date3
            else return
          }
        }
      }
    },
    props: {
      pageTotal: Number
    },
    created() {
      this.token = sessionStorage.getItem('token');
      console.log("this.aasd", this.token)
      this.firstSearch()
      // this.pagNumS()
    },
    mounted() {

    },
    methods: {
      //条数转页数
      pagNumS() {
        let pages = Math.ceil(this.totalCount / 15)
        this.pagNum = pages;
        console.log("aaaa", this.pagNum)
      },
      // 上下分页 pageIndex
      handleCurrentChange(page) {
        let params = {
          identityType: this.req.identityType1, //员工标识:1内勤2外勤
          companyName: this.req.companyName1, //公司名称
          serviceName: this.req.serviceName1, //营服名
          startTime: this.req.startTime1, //注册开始时间
          endTime: this.req.endTime1, //注册结束时间
          acctOpenDateStart: this.req.acctOpenDateStart1, //开户开始时间
          acctOpenDateEnd: this.req.acctOpenDateEnd1, //开户结束时间
          recommendIdcard: this.req.recommendIdcard1, //推荐人身份证号
          recommendPepole: this.req.recommendPepole1, //推荐人姓名
          recommendMobile: this.req.recommendMobile1, //推荐人手机号
          recommendStatus: this.req.recommendStatus1, //推荐人状态
          toRecommendIdcard: this.req.toRecommendIdcard1, //被推荐人身份证号
          toRecommendName: this.req.toRecommendName1, //被推荐人姓名
          toRecommendMobile: this.req.toRecommendMobile1, //被推荐人手机号
          toRecommendStatus: this.req.toRecommendStatus1, //被推荐人状态
          deptId: this.deptId, //中支id
          token: this.token,
          pageNumber: this.currentPage1,
          pageSize: this.pageSize
        };
        console.log('66666666666', params)
        let _this = this;
        let url =  '/ft-oms/wechatUserRelationController/getWechatUserRelation.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      // 每页多少条切换 pageSize
      handleSizeChange(page_size) {
        this.$emit('handleSizeChange', page_size);
        console.log('t5555', this.$emit)
      },
      //获取类别ID
      onSelectedDrug(id) {
        let obj = {};
        obj = this.options.find((item) => {
          return item.value === id; //筛选出匹配数据
        })
        console.log("3333", id); //获取的 id
        // console.log(obj.label); //获取的名称
        this.identityClass = obj.label;
        this.identityClassID = id;
        this.referrerFil();
      },
      //获取分公司ID
      onSelectedDrug1(id) {
        let obj = {};
        obj = this.filiale.find((item) => { //这里的userList就是上面遍历的数据源
          return item.companyId === id; //筛选出匹配数据
        });
        console.log(id); //获取的 id
        this.companyName = obj.companyName;
        this.companyId = id;
        console.log('777777', obj.identity)
        if (obj.identity) { //类别为所有时，重新定义identity
          this.identityClassID = obj.identity
        } else {

        }
        //查中支
        this.referrerMed();
      },
      //获取中支ID和名称 
      onSelectedDrug2(id) {
        let obj = {};
        obj = this.medium.find((item) => { //这里的userList就是上面遍历的数据源
          return item.deptId === id; //筛选出匹配数据
        });
        console.log("中支", id); //获取的 id
        this.deptId = id;
        console.log("this.deptId", this.deptId); //获取的 id
        this.abbrName = obj.deptName
        this.referrerCc();
      },
      //获取营服ID和名称
      onSelectedDrug3(id) {
        let obj = {};
        obj = this.camp.find((item) => { //这里的userList就是上面遍历的数据源
          return item.businessId === id; //筛选出匹配数据
        });
        console.log("营服", id); //获取的 id
        this.serviceID = id;
        this.serviceName = obj.businessName
      },
      //获取推荐人状态ID和名称
      onSelectedDrug4(id) {
        let obj = {};
        obj = this.whetherStaff1.find((item) => { //这里的userList就是上面遍历的数据源
          return item.value === id; //筛选出匹配数据
        });
        console.log("推荐人状态", id); //获取的 id
        this.staffID1 = id;
        this.staffName1 = obj.label
      },
      //获取被推荐人状态ID和名称
      onSelectedDrug5(id) {
        let obj = {};
        obj = this.whetherStaff2.find((item) => { //这里的userList就是上面遍历的数据源
          return item.value === id; //筛选出匹配数据
        });
        console.log("被推荐人状态", id); //获取的 id
        this.staffID2 = id;
        this.staffName2 = obj.label
      },
      //获取注册开始日期
      getSTime1(val1) {
        this.date1 = val1
        console.log(this.date1)
        var d = new Date(this.date1);
        var youWant = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
        console.log("注册开始日期", youWant)
        if (youWant == "1970/1/1") {
          youWant = ""
        }
        this.startTime = youWant
      },
      //获取注册结束日期
      getSTime2(val2) {
        this.date2 = val2
        var d2 = new Date(this.date2);
        var youWant2 = d2.getFullYear() + '/' + (d2.getMonth() + 1) + '/' + d2.getDate();
        console.log("注册结束日期",youWant2)
        if (youWant2 == "1970/1/1") {
          youWant2 = ""
        }
        this.endTime = youWant2
      },
      //获取开户开始日期
      getSTime3(val3) {
        this.date3 = val3
        console.log(this.date3)
        var d3 = new Date(this.date3);
        var youWant3 = d3.getFullYear() + '/' + (d3.getMonth() + 1) + '/' + d3.getDate();
        console.log("开户开始日期", youWant3)
        if (youWant3 == "1970/1/1") {
          youWant3 = ""
        }
        this.acctOpenDateStart = youWant3
      },
      //获取开户结束日期
      getSTime4(val4) {
        this.date4 = val4
        var d4 = new Date(this.date4);
        var youWant4 = d4.getFullYear() + '/' + (d4.getMonth() + 1) + '/' + d4.getDate();
        console.log("开户结束日期",youWant4)
        if (youWant4 == "1970/1/1") {
          youWant4 = ""
        }
        this.acctOpenDateEnd = youWant4
      },
      //首次进入加载数据
      firstSearch() {
        let params = {
          identityType: '', //员工标识:1内勤2外勤
          companyName: '', //公司名称
          serviceName: '', //营服名
          startTime: '', //注册开始时间
          endTime: '', //注册结束时间
          acctOpenDateStart: "", //开户开始时间
          acctOpenDateEnd: "", //开户结束时间
          recommendIdcard: '', //推荐人身份证号
          recommendPepole: '', //推荐人姓名
          recommendMobile: '', //推荐人手机号
          recommendStatus: '',//推荐人状态
          toRecommendIdcard: '', //被推荐人身份证号
          toRecommendName: '', //被推荐人姓名
          toRecommendMobile: '', //被推荐人手机号
          toRecommendStatus: '',//被推荐人状态
          deptId: '', //中支id
          token: this.token,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        };
        let _this = this;
        let url = '/ft-oms/wechatUserRelationController/getWechatUserRelation.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount) //向上取整 parseInt(Math.ceil(res.data.data.totalCount/15))
            this.pagNumS();
            this.isPage = true
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      //搜索数据
      getData() {
        let params = {
          identityType: this.identityClassID, //员工标识:1内勤2外勤
          companyName: this.companyName, //公司名称
          serviceName: this.serviceName, //营服名
          startTime: this.startTime, //注册开始时间
          endTime: this.endTime, //注册结束时间
          acctOpenDateStart: this.acctOpenDateStart, //开户开始时间
          acctOpenDateEnd: this.acctOpenDateEnd, //开户结束时间
          recommendIdcard: this.idCard, //推荐人身份证号
          recommendPepole: this.name, //推荐人姓名
          recommendMobile: this.phone, //推荐人手机号
          recommendStatus: this.staffID1,//推荐人状态
          toRecommendIdcard: this.certNo, //被推荐人身份证号
          toRecommendName: this.customerName, //被推荐人姓名
          toRecommendMobile: this.mobile, //被推荐人手机号
          toRecommendStatus: this.staffID2,//被推荐人状态
          deptId: this.deptId, //中支id
          token: this.token,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        };

        this.req.identityType1 = params.identityType
        this.req.companyName1 = params.companyName
        this.req.serviceName1 = params.serviceName
        this.req.startTime1 = params.startTime
        this.req.endTime1 = params.endTime
        this.req.acctOpenDateStart1 = params.acctOpenDateStart
        this.req.acctOpenDateEnd1 = params.acctOpenDateEnd
        this.req.recommendIdcard1 = params.recommendIdcard
        this.req.recommendPepole1 = params.recommendPepole
        this.req.recommendMobile1 = params.recommendMobile
        this.req.recommendStatus1 = params.recommendStatus
        this.req.toRecommendIdcard1 = params.toRecommendIdcard
        this.req.toRecommendName1 = params.toRecommendName
        this.req.toRecommendMobile1 = params.toRecommendMobile
        this.req.toRecommendStatus1 = params.toRecommendStatus
        this.req.deptId1 = params.deptId
        let _this = this;
        let url =  '/ft-oms/wechatUserRelationController/getWechatUserRelation.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount)
            this.currentPage1 = 1
            this.pagNumS();
            this.isPage = true
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = []
            this.isPage = false
          }
        }, );
      },
      //搜索开户明细
      search() {
        if((this.startTime!=''&&this.endTime!='')||(this.startTime==''&&this.endTime=='')){
          if((this.acctOpenDateStart!=''&&this.acctOpenDateEnd!='')||(this.acctOpenDateStart==''&&this.acctOpenDateEnd=='')){
            this.getData()
          }else{
            this.$alert('请选择开始日期或结束日期', '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {
                
              }
            });
          }
        }else{
          this.$alert('请选择开始日期或结束日期', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }
      },
      //清除数据
      deltale() {
        this.value = ""
        this.identityClassID = "";
        this.value1 = ""
        this.companyName = "";
        this.value2 = ""
        this.abbrName = "";
        this.value3 = ""
        this.serviceName = "";
        this.date1 = "";
        this.date2 = "";
        this.startTime = "";
        this.endTime = "";
        this.date3 = "";
        this.date4 = "";
        this.acctOpenDateStart = "";
        this.acctOpenDateEnd = "";
        this.idCard = "";
        this.name = "";
        this.deptId = "";
        this.phone = "";
        this.certNo = "";
        this.customerName = "";
        this.mobile = "";
        this.value4 = "";
        this.staffID1 = "";
        this.staffID2 = "";
        this.value5 = "";
      },
      //导出
      doexcel() {
        let params = {
          identityType: this.req.identityType1, //员工标识:1内勤2外勤
          companyName: this.req.companyName1 , //公司名称
          serviceName: this.req.serviceName1, //营服名
          startTime: this.req.startTime1, //开始时间
          endTime: this.req.endTime1, //结束时间
          acctOpenDateStart: this.req.acctOpenDateStart1, //开户开始时间
          acctOpenDateEnd: this.req.acctOpenDateEnd1, //开户结束时间
          recommendIdcard: this.req.recommendIdcard1, //推荐人身份证号
          recommendPepole: this.req.recommendPepole1, //推荐人姓名
          recommendMobile: this.req.recommendMobile1, //推荐人手机号
          recommendStatus: this.req.recommendStatus1, //推荐人状态
          toRecommendIdcard: this.req.toRecommendIdcard1, //被推荐人身份证号
          toRecommendName: this.req.toRecommendName1, //被推荐人姓名
          toRecommendMobile: this.req.toRecommendMobile1, //被推荐人手机号
          toRecommendStatus: this.req.toRecommendStatus1, //被推荐人状态
          deptId: this.req.deptId1, //中支id
          token: this.token,
        };
        let _this = this;
        let url =  '/ft-oms/wechatUserRelationController/isExportWechatUserRelation.action'
        this.$http.post(url, params, {
          responseType: 'blob'
        }).then(res => {
          if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          } else{
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            }); // res就是接口返回的文件流了
            let objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          }
        }, );
      },
      //查询分公司
      referrerFil() {
        let data = {
          "identity": this.identityClassID,
          token: this.token
        };
        console.log("55555", data);
        let _this = this;
        let url =  '/ft-oms/OipController/oipQueryCompany.action'
        this.$http.post(url, data).then(res => {
          if (res.data.code == "200") {
            console.log("data1", res.data)
            this.filiale = res.data.data.list
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          }  else {
          }
        })
      },
      //查中支
      referrerMed() {
        let params = {
          "identity": this.identityClassID,
          token: this.token,
          "companyId": this.companyId
        };
        console.log("55555", params);
        let _this = this;
        let url =  '/ft-oms/OipController/oipQueryDept.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1", res.data)
            this.medium = res.data.data.list
            console.log("this.medium+++", this.medium)
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          }  else {
          }
        });
      },
      //查营服
      referrerCc() {
        let data = {
          "identity": this.identityClassID,
          token: this.token,
          "deptId": this.deptId
        };
        console.log("55555", data);
        let _this = this;
        let url =  '/ft-oms/OipController/oipQueryDeptBusiness.action'
        this.$http.post(url, data).then(res => {
          if (res.data.code == "200") {
            this.camp = res.data.data.list
            console.log("this.camp", this.camp)
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          }  else {
          }
        });
      },
    }
  }

</script>

<style scoped>
  .pagination {
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    height: 1.8rem;
    font-size: 0.9rem;
    line-height: 1.8rem;
  }

  .header {
    height: 3rem;
    display: flex;
  }

  .filiale,
  .input {
    margin-right: 1rem;
  }

  .input {
    display: flex;
    border: 1px solid #dedede;
    width: 12rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.25rem;
    color: #bfcbd9;
  }

  .input1 {
    margin-left: 0.5rem
  }

  .input input {
    flex: 9;
    border: 0;
    font-size: 0.8rem;
    width: 6rem;
    outline: none;
  }
  .input input:focus{
    border-color: #FF9D47;
  }
  .input img {
    width: 50%;
    height: 50%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    flex: 1;
    margin-top: 0.4rem;
  }

  .fun {
    display: flex;
    margin-bottom: 1rem;
  }
  .funLeft{
    display: flex;
  }
  .funRight{
    display: flex;
  }
  .btn{
      display: flex;
      justify-content: space-between;
  }
  .openOnAccountTime{
    display: flex;
  }
  .one{
      width:10rem;
  }
  .search {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 0.6rem;
    color: #FF9D47;
  }

  .deltale {
    border: 1px solid #7A7A7A;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 0.6rem;
    color: #7A7A7A;
  }

  .doexcel {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 0.6rem;
    color: #ffffff;
    background: #FF9D47;
  }

  .pagNum {
    margin-left: 1.2rem;
    margin-top: 0.2rem;
  }

  .checkboxImg {
    width: 4.8rem;
    height: 1.2rem;
    border: 1px solid #999999;
    background: url("../../../static/img/sousuo-2.png") no-repeat center right;
  }

  .checkboxDiv {
    width: 4.8rem;
    display: none;
    border: 1px solid #999999;
    border-top: none;
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    content: '';
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check {
    background: #FF9D47;
    border-color: #FF9D47;
    color: #FF9D47;
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check:after {
    transform: rotate(45deg) scaleY(1);
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item .check::after {
    box-sizing: content-box;
    content: '';
    border: 0.01rem solid #fff;
    border-left: 0;
    border-top: 0;
    height: 0.5rem;
    left: 0.1rem;
    position: absolute;
    top: 0.01rem;
    transform: rotate(45deg) scaleY(0);
    width: 0.4rem;
    transition: transform 0.05s ease-in 0.05s;
    transform-origin: center;
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item .check {
    display: inline-block;
    position: relative;
    top: 0.02rem;
    border: 0.01rem solid #D9EBFE;
    border-radius: 0.02rem;
    box-sizing: border-box;
    width: 0.8rem;
    height: 0.8rem;
    border-color: #D9EBFE;
    z-index: 1;
    transition: border-color 0.05s cubic-bezier(.71, -.49, .26, 1.46), background-color 0.05s cubic-bezier(.71, -.49, .26, 1.46);
  }

  .el-input__inner {
    height: 1.8rem;
    font-size: 0.72rem;
  }

  .el-table__header-wrapper {
    background: #fff;
  }

  input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #bfcbd9;
    /* placeholder字体大小 */
    /* font-size: 12px; */
  }

  .startDate,
  .endDate {
    margin-right: 1rem;
  }

  /*修改input框默认文本样式*/
  input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #C1C1C1;
    /* placeholder字体大小 */
    /* font-size: 12px; */
  }
  .el-input__inner {
    height: 1.8rem;
    font-size: 0.72rem;
  }
  /*修改日期框样式*/
  .startDate>>>.el-date-editor {
    width: 9.3rem;
  }

  .startDate>>>.el-input__inner:focus{
    border-color: #FF9D47;
  }
  .endDate>>>.el-date-editor {
    width: 9.3rem;
  }
  .endDate>>>.el-input__inner:focus{
    border-color: #FF9D47;
  }
  
  /*修改下拉框样式*/
  .filiale>>>.el-input__inner{
    width: 8rem;
  }
  .filiale>>>.el-select .el-input.is-focus .el-input__inner{
    border-color: #FF9D47;
  }
  .filiale>>>.el-select .el-input__inner:focus{
    border-color: #FF9D47;
  }
  .el-select-dropdown__item.selected{
    color: #FF9D47;
  }
  .filiale>>>.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #FAF0E7;
    color: #FF9D47;
  }
  
  /*修改分页样式*/
  .pagination>>>.el-pager li.active{
    color: #FF9D47;
  }
  .pagination>>>.el-pager li:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-left:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-right:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-left.active{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-right.active{
    color: #FF9D47;
  }
  .el-icon-arrow-left:hover{
    color: #FF9D47;
  }
  .el-icon-arrow-right:hover{
    color: #FF9D47;
  }
  .el-icon-arrow-left.active{
    color: #FF9D47;
  }
  .el-icon-arrow-right.active{
    color: #FF9D47;
  }
  .pagination>>>.el-pagination .btn-next:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-pagination .btn-prev:hover{
    color: #FF9D47;
  }
  /*按钮样式*/
  .doexcel>>> .el-button--default .el-button--mini:hover{
    background-color: #FF9D47 !important;
    color: #ffffff;
    border-color: #FF9D47;
  }
  .search>>>.el-button--default .el-button--mini:hover{
    background-color: #ffffff !important;
    color: #FF9D47;
    border-color: #FF9D47;
  }
  .deltale>>> .el-button--default .el-button--mini:hover{
    background-color: #ffffff !important;
    color: #000;
    border-color: #000;
  }
  .filiale >>>.el-select-dropdown__wrap{
    max-height: 295px;
  }
</style>



// WEBPACK FOOTER //
// client1.vue?13fcc57e